import _extends from "@babel/runtime/helpers/esm/extends";
import { slug } from '@magalu/mixer-utils';
export var buildFilterClick = function buildFilterClick(_ref) {
  var _data$search, _data$search$term;
  var data = _ref.data,
    contentType = _ref.contentType,
    contentId = _ref.contentId;
  var termSearched = (data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$term = _data$search.term) == null ? void 0 : _data$search$term.raw) || '';
  return {
    content_id: contentId,
    content_type: contentType,
    event: 'select_content',
    raw: termSearched
  };
};
export var fastFilterClick = function fastFilterClick() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    filterValue = _ref2.slug;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildFilterClick(_extends({}, args, {
    contentId: "marcas-mais-buscadas:".concat(slug(filterValue)),
    contentType: 'busca:filtro-rapido'
  }));
};
export var filterClean = function filterClean() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildFilterClick(_extends({}, args, {
    contentId: 'limpar-tudo',
    contentType: 'busca:filtro'
  }));
};
export var filterItemClick = function filterItemClick() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    filterLabel = _ref3.filterLabel,
    label = _ref3.label,
    _ref3$selected = _ref3.selected,
    selected = _ref3$selected === void 0 ? false : _ref3$selected;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var action = selected ? 'remover-filtro' : 'aplicar-filtro';
  return buildFilterClick(_extends({}, args, {
    contentId: "".concat(action, ":").concat(slug(label)),
    contentType: "busca:".concat(slug(filterLabel), ":filtro")
  }));
};
export var filterRemove = function filterRemove(item) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var label = (item == null ? void 0 : item.slug) || '';
  return buildFilterClick(_extends({}, args, {
    contentId: "remover-filtro:".concat(slug(label)),
    contentType: "busca:filtro"
  }));
};